module.exports = __webpack_public_path__ + "media/newstyle/images/clube-icon-decorator-8216c98d6cc289bc0ee9d0774cf5b62c.png";